import DOMPurify from 'dompurify';

/**
 * Allow-list for rich-text content. Deliberately narrow — this is the single security boundary
 * between authored HTML and what the filler's browser renders.
 *
 * Tiptap emits only semantic tags (`<strong>`, `<em>`, `<u>`, `<s>`, `<h1>`, `<ul>`…) with no
 * attributes, so no attributes are allowed through — anything else is stripped on display.
 */
const ALLOWED_TAGS = ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'h1', 'h2', 'h3', 'ul', 'ol', 'li'];
const ALLOWED_ATTR: string[] = [];

/** Sanitises authored rich-text HTML to the allow-listed subset. Safe to render via dangerouslySetInnerHTML. */
export function sanitizeRichTextHtml(html: string | null | undefined): string {
  return DOMPurify.sanitize(html ?? '', { ALLOWED_TAGS, ALLOWED_ATTR });
}

/** True when sanitised content has no visible text or elements (treat as "no content"). */
export function isRichTextEmpty(html: string | null | undefined): boolean {
  const clean = sanitizeRichTextHtml(html);
  // Strip tags, then non-breaking spaces (entity + literal) and remaining whitespace. An empty editor
  // serialises to e.g. "<p></p>" / "<p><br></p>", which reduces to "" here.
  return clean
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, '')
    .replace(/\u00A0/g, '')
    .replace(/\s/g, '')
    .trim() === '';
}
